import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import { checkIsAdmin } from '@coparent/shared/src/services/adminMetricsService';

const AdminContext = createContext({ isAdmin: false, loading: true });

export const useAdmin = () => useContext(AdminContext);

export const AdminProvider = ({ children }) => {
  const { currentUser } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    if (!currentUser?.uid) {
      setIsAdmin(false);
      setLoading(false);
      return;
    }
    setLoading(true);
    checkIsAdmin(currentUser.uid).then((ok) => {
      if (cancelled) return;
      setIsAdmin(ok);
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, [currentUser?.uid]);

  return (
    <AdminContext.Provider value={{ isAdmin, loading }}>
      {children}
    </AdminContext.Provider>
  );
};
